import { useParams } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import useTestDetailPageController from '../../1_application/test/testDetailPageController';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { Test, TestContext } from '../../2_domain/test/test';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';
import toIDString from '../../lib/util/dateFormatter';
import ClientInfoView from '../client/components/clientInfoView';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXBack from '../core/components/buttons/lxBack';
import LXLargeButton from '../core/components/buttons/lxLargeButton';
import LXSelector from '../core/components/buttons/lxSelector';
import { XCenter } from '../core/components/center';
import LXError from '../core/error/lx_error';
import LXSpinner from '../core/spinner/lx_spinner';
import { LXbody, LXh1, LXh4 } from '../core/texts/lxText';
import InformationCard from './components/informationCard';
import TestItemList from './components/testItemList';
// import TestReportList from './components/testReportList';

const CardContainer = styled.div`
  padding: 30px;
  border: ${(props) => `1px solid ${props.theme.colors.white}`};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 12px;
`;

interface TestDetailPageProps {
  test: Test;
}

const TestDetailPage = (props: TestDetailPageProps) => {
  const theme = useTheme();
  const c = useTestDetailPageController(props.test);

  const controllHeader = (
    <Row justifyContent="space-between" alignItems="center">
      <LXBack></LXBack>
      <LXSelector<'Cancel'>
        kind={'secondary'}
        placeholder={theme.texts.manage}
        values={['Cancel']}
        labels={[theme.texts.cancel]}
        onSelect={c.onManage}
        dropdownItemWidth={120}
      ></LXSelector>
    </Row>
  );

  const testSerialText = (
    <LXh4 color={theme.colors.pinkBg}>{`#${c.test.serial}`}</LXh4>
  );

  const buildTestNameText = () => {
    // return (
    //   <Row>
    //     <LXh1>{c.test.name}</LXh1>
    //     <SizedBox width={4}></SizedBox>
    //     <LXh1 color={theme.colors.caption}>{`+${
    //       c.test.testItemList.length - 1
    //     }`}</LXh1>
    //   </Row>
    // );
    if (c.test.testItemList.length > 1) {
      return (
        <Row>
          <LXh1>{c.test.name}</LXh1>
          <SizedBox width={4}></SizedBox>
          <LXh1 color={theme.colors.caption}>{`+${
            c.test.testItemList.length - 1
          }`}</LXh1>
        </Row>
      );
    } else {
      return <LXh1>{c.test.name}</LXh1>;
    }
  };

  const informationHeader = (
    <Row justifyContent="space-between">
      <LXh4>{theme.texts.information}</LXh4>
      <LXbody color={theme.colors.caption}>{`Registration Date: ${toIDString(
        c.test.createdAt
      )}`}</LXbody>
    </Row>
  );

  //TODO:
  const buildTestReportList = () => {
    return (
      <Column>
        <LXh4>{theme.texts.testItem}</LXh4>
        <SizedBox height={16}></SizedBox>
        <CardContainer>
          <Column>
            {
              /* <TestReportList items={c.test.testItemList}></TestReportList> */ <TestItemList
                testItems={(c.test.testItemList as any).testItem.map(
                  (d: any) => d
                )}
              ></TestItemList>
            }
            <SizedBox height={40}></SizedBox>
            <Row justifyContent="center">
              <LXLargeButton onClick={c.onDownloadReportHandler}>
                {theme.texts.downloadTestReport}
              </LXLargeButton>
              <SizedBox height={40}></SizedBox>
            </Row>
          </Column>
        </CardContainer>
      </Column>
    );
  };

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        {controllHeader}
        <SizedBox height={60}></SizedBox>
        {testSerialText}
        <SizedBox height={4}></SizedBox>
        {buildTestNameText()}
        <SizedBox height={40}></SizedBox>
        {informationHeader}
        <SizedBox height={16}></SizedBox>
        <CardContainer>
          <InformationCard test={c.test}></InformationCard>
        </CardContainer>
        <SizedBox height={40}></SizedBox>
        {c.test.testStatus.context === TestContext.DONE ? (
          buildTestReportList()
        ) : (
          <TestItemList
            testItems={(c.test.testItemList as any).testItem.map((d: any) => d)}
          ></TestItemList>
        )}
        <SizedBox height={40}></SizedBox>
        <LXh4>{theme.texts.client}</LXh4>
        <SizedBox height={16}></SizedBox>
        <CardContainer>
          <ClientInfoView client={c.test.patient}></ClientInfoView>
        </CardContainer>
      </Column>
    </XCenter>
  );
};

const TestDetailPageWrapper = () => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const { testId } = useParams();
  const test = wrapPromise<number, Test>(
    testRepo.getTestById,
    testId as any,
    'testRepoKey'
  )();
  return <TestDetailPage test={test}></TestDetailPage>;
};

export default withAsync({
  child: TestDetailPageWrapper,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
